'use client';

import { useEffect, type ReactNode } from 'react';

import { useRouter } from 'next/navigation';

import { onMessage } from 'firebase/messaging';

import { useFCM } from '@/hooks/useFCM';
import { useSnackbar } from '@/hooks/useSnackbar';

import { messaging } from '@/firebase/firebaseConfig';

import { Or2Button } from '../button/Or2Button';

interface Props {
  children: ReactNode;
}

export const FCMProvider = ({ children }: Props) => {
  useFCM(); // Initialize FCM, register device, etc.
  const router = useRouter();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    const fcmmessaging = messaging();
    const unsubscribe = onMessage(fcmmessaging, (payload) => {
      const data = (payload?.data ?? {}) as Record<string, string | undefined>;

      const body = payload?.notification?.body ?? data.body ?? '';
      const baseUrl = window.location.origin;
      const relativeUrl = data.relativeUrl || data.url || data.link;
      const url = relativeUrl
        ? `${baseUrl}/${relativeUrl.replace(/^\/?/, '')}`
        : undefined;

      const key = enqueueSnackbar(body, {
        variant: 'info',
        persist: true,
        hideIconVariant: false,
        dismissible: true,
        action: url
          ? () => (
              <Or2Button
                onClick={() => {
                  try {
                    router.push(url);
                    closeSnackbar(key);
                  } catch {
                    // noop
                  }
                }}
              >
                View
              </Or2Button>
            )
          : undefined,
      });
    });
    return () => unsubscribe();
  }, [enqueueSnackbar, closeSnackbar, router]);

  return <>{children}</>;
};
